export default "__VITE_ASSET__CyaVlBXL__"